import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';
import { useRouter } from 'next/router';

import useCurrentCourse from '@src/hooks/useCurrentCourse';
import ShareButton from '@src/components/common/shareButton';
import RatingStars from './ratingStars';
import Views from './views';

const ChipsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin-top: 8px;
	& > div:not(:last-child) {
		margin-right: 8px;
	}
`;

const Chip = styled.div`
	cursor: pointer;
	line-height: 20px;
	border: 1px solid #DDD;
	border-radius: 50px;
	font-size: 14px;
	padding: 4px 9px 4px 12px;
	white-space: nowrap;
	margin-top: 4px;
	border-color: ${props => (props.isSelect ? props.theme.colors.primary : '#DDDDDD')};
	&:before {
		content: '# ';
	}
	:hover {
		border-color: ${props => props.theme.colors.primary};
		background-color: ${props => props.theme.colors.primary};
		color: #fff};

	}
`;

const DetailContent = styled.div`
	width: 100%;

	@media
		${props => props.theme.device.tablet},
		${props => props.theme.device.smTablet},
		${props => props.theme.device.mobile}
	{
		margin-top: 16px;
	}
`;

const FlexRow = styled.div`
	display: flex;
	align-items: center;
	& > *:not(:first-child) {
		margin-left: 16px;
	}
`;

const FlexSpaceBetween = styled.div`
	display: flex;
	justify-content: space-between;

	@media
		${props => props.theme.device.mobile}
	{
		flex-direction: column;
		& > *:not(:first-child) {
			margin-top: 12px;
		}
	}
`;

const Divider = styled.div`
	width: 1px;
	background: #DDD;
	height: 16px;
`;

const Detail = (): JSX.Element => {
	const { t } = useTranslation();
	const router = useRouter();
	const { currentCourse: {
		rate, views, tags, categories,
	} } = useCurrentCourse();
	return (
		<DetailContent>
			<FlexSpaceBetween>
				<FlexRow>
					<RatingStars totalScore={rate.total_score} totalVotes={rate.total_votes} />
					<Divider />
					<Views views={views} />
				</FlexRow>
				<FlexRow>
					<ShareButton
						text={t('course:share')}
						modalTitle={t('share_button:title')}
					/>
				</FlexRow>
			</FlexSpaceBetween>
			{/* Chips component should be used in common. */}
			<ChipsWrapper>
				{categories.map(keyword => (
					<Chip key={keyword.short_link} onClick={() => router.push(`/category/${keyword.short_link}`)}>
						{keyword?.name || keyword || ''}
					</Chip>
				))}
				{tags.map(keyword => (
					<Chip key={keyword.id} onClick={() => router.push(`/category/all?tag_ids=${keyword?.id}`)}>
						{keyword?.name || keyword || ''}
					</Chip>
				))}
			</ChipsWrapper>
		</DetailContent>
	);
};

export default Detail;
